import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { route } from './route'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  route('/', 'app/v1/views/TedsLauncherMain/TedsLauncherMain'),
  route('/settings', 'app/v1/views/TedsLauncherSettings/TedsLauncherSettings'),
]

const router = new VueRouter({
  routes,
})

export default router
